import queryString from 'query-string';
import { requestWithAuth } from './utils';
import { RESOURCE_TYPE_ID } from './constants';

export const fetchResource = (resource) => {
  const apiResource = getApiResource(resource);
  return requestWithAuth(`${process.env.REACT_APP_API_HOST}/api/v1/${apiResource}`);
};

/**
 * Helper for saving a new resource
 * @param {string} resource 'Resource name'
 * @param {object} data FORM data
 * @param {object} options Option params (path)
 */
export const saveResource = (resource, data, options = {}) => {
  if (
    !resource || typeof resource === 'undefined' ||
      (!data || typeof data !== 'object') ||
      (!options || typeof options !== 'object')
  ) {
    throw new TypeError('Incorrect saveResource params');
  }
  const apiResource = getApiResource(resource);
  const endpoint = Object.prototype.hasOwnProperty.call(options, 'path')
    ? `${process.env.REACT_APP_API_HOST}/api/v1/${options.path}`
    : `${process.env.REACT_APP_API_HOST}/api/v1/${apiResource}`;

  // (url, method = 'GET', headers = {}, body = {})
  return requestWithAuth(endpoint, 'POST', {}, data);
};

export const getResourceCSV = (resource, resourceTypeId, params = {}) => {
  const query = queryString.stringify(params);
  const endpoint = `${process.env.REACT_APP_API_HOST}/api/v1/tasks/csv?${query}`;
  return requestWithAuth(endpoint, 'GET');
};

export const getApiResource = (resource) => {
  const resources = getTasksResources();
  if (Object.keys(resources).includes(resource)) {
    return 'tasks';
  }

  return resource;
};

// TODO - Get these status from API
export const getStatuses = () => [
  {
    name: 'failed',
    label: 'Failed',
    id: 5,
  },
  {
    name: 'done',
    label: 'Done',
    color: 'success',
    id: 4,
  },
  {
    name: 'started',
    label: 'Started',
    id: 3,
  },
  {
    name: 'queued',
    label: 'Queued',
    id: 2,
  },
  {
    name: 'open',
    label: 'Open',
    id: 1,
  },
];

export const getStatusById = (id) => {
  const statuses = getStatuses();
  return statuses.find(status => status.id === id);
};

export const getTasksResources = () => ({
  generatePreview: {
    id: RESOURCE_TYPE_ID.GENERATE_PREVIEW,
    permalink: 'generate-preview',
    title: 'Generate preview',
  },
  resendNewsletter: {
    id: RESOURCE_TYPE_ID.RESEND_NEWSLETTER,
    permalink: 'resend-newsletter',
    title: 'Resend newsletter',
  },
});

export const getTaskResourceById = (id) => {
  const resources = getTasksResources();
  const resourceKey = Object.keys(resources).filter(key => resources[key].id === id);
  return resourceKey;
};



// WEBPACK FOOTER //
// ./src/helpers/resources.js